import React, { useCallback, useEffect, useState } from "react";
import { Flame, HeartHandshake, Trophy } from "lucide-react";
import { api } from "@/lib/api";
import PostCard from "@/components/PostCard";
import { MissionCard } from "@/components/MissionCard";
import { StreakBadges } from "@/components/StreakBadges";

const RANK_BG = { 1: "bg-accent", 2: "bg-sage", 3: "bg-secondary" };

export default function TrendingPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mission, setMission] = useState(null);

  const loadMission = useCallback(() => {
    api.get("/missions/today").then((response) => setMission(response.data))
      .catch((error) => console.warn("Failed to load missions", error));
  }, []);

  useEffect(() => {
    api.get("/discovery/trending").then((response) => setPosts(response.data))
      .catch((error) => console.warn("Failed to load trending", error))
      .finally(() => setLoading(false));
    loadMission();
    window.addEventListener("haeven:mission", loadMission);
    return () => window.removeEventListener("haeven:mission", loadMission);
  }, [loadMission]);

  return (
    <div data-testid="trending-page">
      <div className="mb-6">
        <h1 className="text-4xl flex items-center gap-2"><Flame size={32} strokeWidth={2.5} /> Trending</h1>
        <p className="text-muted-foreground mt-1">The Kind Ten — this week&apos;s most-loved posts. Only kindness trends here.</p>
      </div>

      {mission && (
        <MissionCard
          icon={HeartHandshake}
          title="Send Warmth"
          subtitle="React kindly to 3 posts today — likes and comments count. Keep the streak alive."
          tasks={[{ label: "Kind reactions", count: mission.warmth.count, goal: mission.warmth.goal }]}
          done={mission.warmth.done}
          doneLabel="Warmth sent — you made today softer. Come back tomorrow!"
          streak={mission.warmth_streak}
          testId="warmth-mission"
        />
      )}

      {mission && <StreakBadges badges={mission.badges} />}

      {loading ? (
        <div className="brutal-card p-6 bg-card">Finding this week&apos;s kindest posts…</div>
      ) : posts.length === 0 ? (
        <div className="brutal-card p-6 bg-card text-muted-foreground">Nothing trending yet — be the post everyone loves this week.</div>
      ) : (
        <div className="space-y-5">
          {posts.map((post) => (
            <div key={post.id} className="relative" data-testid={`trending-rank-${post.rank}`}>
              <span className={`absolute -top-3 -left-3 z-10 brutal-btn px-2.5 py-1 text-sm font-bold ${RANK_BG[post.rank] || "bg-card"} inline-flex items-center gap-1`}>
                {post.rank <= 3 && <Trophy size={13} strokeWidth={2.5} />} #{post.rank}
              </span>
              <PostCard post={post} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
